// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2c0cY","buttons":"Footer_buttons__3BkT-"};